import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { useInput, InputProps } from "react-admin";
import { IconButton, InputAdornment } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface DateFieldComponentProps extends InputProps {
  label?: string;
  showClearIcon?: boolean; // 新增属性
}

const DateFieldComponent: React.FC<DateFieldComponentProps> = (props) => {
  const {
    field,
    fieldState: { error },
    formState: { isSubmitting },
  } = useInput(props);

  const handleClear = () => {
    field.onChange(null);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="zh-cn">
      <DatePicker
        label={props.label || "日期"}
        value={field.value ? dayjs(field.value) : null}
        onChange={(value: dayjs.Dayjs | null) =>
          field.onChange(
            value
              ? value.hour(8).minute(0).second(0).millisecond(0).toDate()
              : null
          )
        }
        slotProps={{
          textField: {
            size: "small",
            error: !!error,
            helperText: error?.message,
            InputProps: {
              startAdornment: props.showClearIcon ? (
                <InputAdornment position="start">
                  <IconButton
                    aria-label="清空日期"
                    onClick={handleClear}
                    disabled={isSubmitting}
                  >
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              ) : null,
            },
          },
        }}
        format="YYYY年MM月DD日"
        disabled={isSubmitting}
      />
    </LocalizationProvider>
  );
};

export default DateFieldComponent;
